import { createEvent, sample } from 'effector';
import { showInputModal } from '@components/InputModal';
import {
  $categoryMap,
  $categoryMapApi,
  $curCategoryId,
  $selectedPathApi,
} from '@stores/dataStores';
import { getNewCategoryId } from '../utils/getNewCategoryId';

const addSubCateEvent = createEvent<{
  id: number;
  name: string;
  targetCategoryId?: number;
}>();

const addSubCategory = async (targetId?: number) => {
  const { value } = await showInputModal({
    title: '新建二级分组',
    maxLength: 50,
    placeholder: '请输入分组名称',
  });
  if (value) {
    const newId = getNewCategoryId();
    addSubCateEvent({ id: newId, name: value, targetCategoryId: targetId });
    return newId;
  }
};

sample({
  source: {
    map: $categoryMap,
    curCategoryId: $curCategoryId,
  },
  clock: addSubCateEvent,
  fn: (source, clock) => ({ ...source, ...clock }),
}).watch(({ map, id, name, curCategoryId, targetCategoryId }) => {
  const categoryId = targetCategoryId ?? curCategoryId;
  const category = map.get(categoryId);
  if (!category) return;
  if (category.categoryIds.length) {
    $categoryMapApi.update((draft) => {
      draft.set(id, { id, name, sceneIds: [], categoryIds: [] });
      draft.get(categoryId)?.categoryIds.push(id);
    });
  } else {
    // 如果原本没有二级分组，则把原场景列表移到新建的二级分组下
    const { sceneIds } = category;
    $categoryMapApi.update((draft) => {
      const item = draft.get(categoryId);
      if (!item) return;
      draft.set(id, { id, name, sceneIds, categoryIds: [] });
      item.categoryIds.push(id);
      item.sceneIds = [];
    });
    $selectedPathApi.update((draft) => {
      draft.categoryPath = [categoryId, id];
    });
  }
});

export default addSubCategory;
